import { format } from "d3-format";
import {
  currencyFormat,
  DurationType,
  currencyNumberFormat,
  numberToDecimalFormat,
} from "./constant";
import RiskProfile from "../models/riskprofiles";

export default {
  convertAmountIntoCurrency(amount) {
    if (isNaN(amount)) {
      return amount;
    }
    return format(currencyFormat)(amount);
  },
  convertAmountIntoDecimalFormat(amount) {
    if (isNaN(amount)) {
      return amount;
    }
    return format(numberToDecimalFormat)(amount);
  },

  formatDate(date, isShowMonth = true, separator = " ") {
    const fullMonth = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = !isShowMonth
        ? "" + parseInt(d.getMonth() + 1)
        : "" + fullMonth[d.getMonth()],
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join(separator);
  },
  calculatePensionPercentage(age) {
    if (age < 65) {
      return 2;
    } else if (age >= 65 && age < 75) {
      return 2.5;
    } else if (age >= 75 && age < 80) {
      return 3;
    } else if (age >= 80 && age < 85) {
      return 3.5;
    } else if (age >= 85 && age < 90) {
      return 4.5;
    } else if (age >= 90 && age < 95) {
      return 5.5;
    } else if (age >= 95) {
      return 7;
    }
  },
  groupBy(propertyName, data) {
    return Object.values(
      data.reduce((acc, obj) => {
        const data = obj[propertyName];
        (acc[data] = acc[data] || []).push(obj);
        return acc;
      }, {})
    );
  },
  convertIntoCurrencyWithoutDecimal(amount) {
    if (isNaN(amount)) {
      return amount;
    }
    return format(currencyNumberFormat)(amount);
  },

  convertAmountIntoNumber(amount) {
    if (isNaN(amount)) {
      return amount;
    }
    return format(".2s")(amount);
  },
  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  },
  addConstantSymbolInNumber(number, symbol) {
    return `${number}${symbol}`;
  },
  getMonthName(monthNumber) {
    return new Date("1999-" + monthNumber + "-15").toLocaleString("en-us", {
      month: "short",
    });
  },

  getMonthfromMonthYear(val) {
    return val.slice(0, val.indexOf("/"));
  },
  getNextDate(date) {
    let previousMonth = this.getMonthfromMonthYear(date);
    let nextYear = this.getYearfromMonthYear(date);
    let nextmonth = Number(previousMonth) + 1;

    if (Number(nextmonth) > 12) {
      nextmonth = 1;
      nextYear = Number(nextYear) + 1;
    }
    let nextDate = ("0" + nextmonth).slice(-2) + "/" + nextYear;
    return nextDate;
  },

  camelCase(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index == 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  },
  toPascalCase(str) {
    return str.replace(/\w+/g, function (w) {
      return w[0].toUpperCase() + w.slice(1).toLowerCase();
    });
  },
  stringtoPascal(str) {
    let words = str.split(" ");
    let newdata = "";
    words.forEach((element) => {
      newdata += this.toPascalCase(element) + " ";
    });
    return newdata;
  },
  getYearfromMonthYear(val) {
    return val.slice(val.indexOf("/") + 1, val.length);
  },
  getRepaymentSubtypes(subtypeid) {
    return subtypeid;
  },
  getRaymentType(repaymentId) {
    if (repaymentId == 1) {
      return "Regular";
    } else if (repaymentId == 2) {
      return "Lump Sum";
    }
  },
  ConvertObjectIntoApiModel(data) {
    let NewData = [];
    for (let i = 0; i < data.length; i++) {
      let currentRow = data[i];
      NewData[i] = {};
      for (var key of Object.keys(currentRow)) {
        NewData[i][key] = this.getvalue(currentRow[key]);
      }
    }
    return NewData;
  },
  createrowModel(data) {
    let NewData = [];
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let currentRow = data[i];
        NewData[i] = {};
        for (var key of Object.keys(currentRow)) {
          NewData[i][key] = {
            value: currentRow[key],
            IsError: false,
            ErrorText: [],
          };
        }
      }
    }
    return NewData;
  },
  getvalue(data) {
    if (data == undefined) return 0;
    else return data.value;
  },

  GetNonSuperDefaultRiskProfileModel(riskprofiles, nonSuperBalance) {
    let nonSuperData = [];
    let income = riskprofiles.income;
    let growth = riskprofiles.growth;

    nonSuperData.push({
      currentValue: {
        value: nonSuperBalance, //this.selectedSuperannuationData.otherDetail.nonSuperBalance,
      },
      incomeReturn: { value: income },
      growthReturn: { value: growth },
      contribution: { value: 0 },
      nonSuperType: { value: 1 },
    });
    return nonSuperData;
  },
  getClientRiskProfileModel(riskprofiles, clientId) {
    let income = RiskProfile.getRiskProfileValue(
      riskprofiles,
      clientId,
      6,
      6,
      "incomeRate"
    );
    let growth = RiskProfile.getRiskProfileValue(
      riskprofiles,
      clientId,
      6,
      6,
      "growthRate"
    );
    return { income: income, growth: growth };
  },

  calculateMonth(userEnteredMonth) {
    let year = parseInt(userEnteredMonth / 12);
    let months = userEnteredMonth % 12;
    let returnMessage = "";
    if (year > 0) {
      returnMessage = `${year} Years`;
    }
    if (months > 0) {
      returnMessage = returnMessage + ` ${months} Months`;
    }
    if (returnMessage == "") {
      return "0 Months";
    } else {
      return returnMessage;
    }
  },
  getFrequencyName(frequencyType) {
    if (frequencyType == DurationType.Weeks) {
      return "Weekly";
    } else if (frequencyType == DurationType.Fortnights) {
      return "Fortnightly";
    } else if (frequencyType == DurationType.Half_Year) {
      return "Half Yearly";
    } else if (frequencyType == DurationType.Years) {
      return "Yearly";
    } else if (frequencyType == DurationType.Months) {
      return "Monthly";
    } else {
      return "";
    }
  },
  getFormProperties(key, formModel) {
    let elementIndex = formModel.elements.findIndex((sr) => sr.htmlName == key);
    if (elementIndex >= 0) {
      return formModel.elements[elementIndex]["value"];
    }
  },
  compareDates(StartYear, StartMonth, StartDay, ENdYear, EndMonth, EndDay) {
    let S1 = new Date(StartMonth + "/" + StartDay + "/" + StartYear);
    let E1 = new Date(EndMonth + "/" + EndDay + "/" + ENdYear);
    if (!S1.valueOf() || !E1.valueOf()) return true;
    return S1 >= E1;
  },

  convertDateToMonthYear(val) {
    if (!val) {
      return val;
    } else {
      let date = new Date(val);
      return ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
    }
  },
  defaultStringValue(element) {
    if (!element) {
      return "";
    } else {
      return element;
    }
  },
  defaultDateValue(element) {
    if (!element || element == "") {
      return "";
    } else {
      let isDateAppend = element.split("/");
      if (isDateAppend.length > 2) {
        return element;
      }
      return "01/" + element;
    }
  },
  defaultIntValue(element) {
    if (!element || isNaN(element)) {
      return 0;
    } else {
      return element;
    }
  },
  defaulAdvanceDateValue(element) {
    if (element && element.value != undefined) {
      return this.defaultDateValue(element.value);
    } else {
      return this.defaultDateValue(element);
    }
  },
  defaulAdvanceIntValue(element) {
    if (element && element.value != undefined) {
      return this.defaultIntValue(element.value);
    } else {
      return this.defaultIntValue(element);
    }
  },
  CompareOverlappingDates(
    StartYear,
    StartMonth,
    StartDay,
    ENdYear,
    EndMonth,
    EndDay,
    StartYear2,
    StartMonth2,
    StartDay2,
    ENdYear2,
    EndMonth2,
    EndDay2
  ) {
    let S1 = new Date(StartMonth + "/" + StartDay + "/" + StartYear);
    let E1 = new Date(EndMonth + "/" + EndDay + "/" + ENdYear);
    let S2 = new Date(StartMonth2 + "/" + StartDay2 + "/" + StartYear2);
    let E2 = new Date(EndMonth2 + "/" + EndDay2 + "/" + ENdYear2);

    return (S2 > E1 && S1 < E2) || (S2 < E1 && S1 > E2);
  },

  getRoundOffValueForAxis(start, stop, count) {
    const e10 = Math.sqrt(50),
      e5 = Math.sqrt(10),
      e2 = Math.sqrt(2);
    var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
    let range =
      power >= 0
        ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) *
          Math.pow(10, power)
        : -Math.pow(10, -power) /
          (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
    if (stop % range != 0) {
      range = stop - (stop % range) + range;
    } else {
      range = stop + range;
    }
    return range;
  },
  getStepOfAxis(start, stop, count) {
    if (stop < count) {
      return 1;
    }
    const e10 = Math.sqrt(50),
      e5 = Math.sqrt(10),
      e2 = Math.sqrt(2);
    var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
    let range =
      power >= 0
        ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) *
          Math.pow(10, power)
        : -Math.pow(10, -power) /
          (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
    return range;
  },

  getXAxisStackArray(start, stop, step) {
    let Outputrange = [];

    let totalElement = stop / step;
    for (let i = start; i < totalElement; i++) {
      Outputrange.push(i * step);
    }
    return Outputrange;
  },
  getRetirementDate(dob, retirementAge) {
    let DateOfBirth = new Date(dob);
    let month = DateOfBirth.getMonth() + 1;
    let year = DateOfBirth.getFullYear() + retirementAge;
    let RetirementDate = new Date(year, month - 1, 1);
    return RetirementDate;
  },
  getRetirementMonthAndYear(dob, retirementAge) {
    let DateOfBirth = new Date(dob);
    let month = DateOfBirth.getMonth() + 1;
    let year = DateOfBirth.getFullYear() + retirementAge;

    return ("0" + month).slice(-2) + "/" + year;
  },
  getAmountByDurationType(amount, durationType) {
    let baseAmount = Number(amount);
    if (durationType == DurationType.Years) {
      return baseAmount;
    } else if (durationType == DurationType.Fortnights) {
      return baseAmount * 26;
    } else if (durationType == DurationType.Months) {
      return baseAmount * 12;
    } else if (durationType == DurationType.Half_Year) {
      return baseAmount * 2;
    } else if (durationType == DurationType.Weeks) {
      return baseAmount * 52;
    } else {
      return baseAmount;
    }
  },
};
